"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultColors = void 0;
exports.defaultColors = {
  backgroundColor: "#ecf0f1",
  selectedBackgroundColor: "#2ecc71",
  fontColor: "#000",
  selectedFontColor: "#fff"
};